// framework/src/common/schemas/collections/playbooks.js
import { z } from 'zod';

const PlaybookResourceSchema = z.object({
    fileId:   z.string().describe('Generated unique ID for this resource file'),
    fileName: z.string().describe('Original file name, e.g. "brief-template.docx"'),
    mimeType: z.string().optional().default('application/octet-stream'),
    size:     z.number().int().optional().default(0),
});

const PlaybookSchema = z.object({
    _id:           z.string().optional().describe('MongoDB ObjectId'),
    subscriptionId: z.string().describe('Owning subscription'),
    projectId:     z.string().optional().nullable().describe('Optional project scope'),

    // Identity
    name:        z.string().min(1).regex(/^[a-z0-9-]+$/, 'Name must be lowercase slug')
                   .describe('Unique slug identifier, e.g. "create-project-brief"'),
    displayName: z.string().min(1).describe('Human-readable name'),
    description: z.string().describe('What this playbook does and when to use it — shown to agent during search'),
    tags:        z.array(z.string()).optional().default([]),
    version:     z.string().optional().default('1.0.0'),

    // Source — file-backed playbooks are read-only (loaded from disk at startup)
    source: z.enum(['db', 'file']).default('db'),

    // The procedural instructions the agent reads and follows when the playbook is loaded
    instructions: z.string().describe('Full markdown body of the playbook'),

    // Context enrichment applied when the playbook is loaded
    linkedSkills:      z.array(z.string()).optional().default([])
                         .describe('Subconscious skill names to activate'),
    linkedDataLoaders: z.array(z.string()).optional().default([])
                         .describe('Dataset keys to pre-fetch into agent context'),
    additionalTools:   z.array(z.string()).optional().default([])
                         .describe('Tool names to register in the agent\'s active tool set'),
    commands:          z.array(z.string()).optional().default([])
                         .describe('AI command grants to add while this playbook is loaded'),

    // Resource files stored in SeaweedFS at vpc-volumes/playbooks/{_id}/resources/
    resources: z.array(PlaybookResourceSchema).optional().default([]),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default PlaybookSchema;
